import React from 'react';
import { Link } from "gatsby"
import parse from 'html-react-parser';

export const TrainingSliderCard = ({ uri, slug, acf, title, type }) => {
  
  const urlbase = type === `training` ? `usecase` : `tutorial`;
  
  return (
    <Link
      className={`w-full h-60 sm:h-52 md:h-56 lg:h-60 rounded-2xl overflow-hidden `}
      to={uri && `/usecase/${slug}`}
    >
      <div className={`px-4 md:px-6 h-full pb-4 pt-4  relative `}>
        <div className="flex flex-col h-full">
          <h4
            className={`text-white mt-0  text-xl-v0 sm:text-xl ellipsis-title-2 font-black leading-8 `}
            dangerouslySetInnerHTML={{ __html: title }}
          ></h4>
          <div className={`text-white mt-6 text-xs sm:text-base ellipsis-card-large-p h-full w-full `}>
            {parse(acf?.tenjinCardExcerpt || '')}
          </div>
          <div className='absolute flex justify-between flex-row items-center w-91 bottom-5'>
            <div className="flex flex-shrink-0 space-x-1" >
              {acf?.tenjinRelatedContent?.length > 0 &&
                acf?.tenjinRelatedContent
                  ?.map((trainIcon, index) => {
                    if (trainIcon.acf?.iconColor) {
                      return (
                        <div
                          className='px-1 py-1 w-8 h-8 bg-white rounded-full'>
                          <img
                            key={index}
                            className={`w-6 h-6`}
                            alt={trainIcon.acf?.iconAlt ?? trainIcon.title}
                            src={
                              trainIcon.acf?.iconColor?.sourceUrl
                                ? trainIcon.acf.iconColor.sourceUrl
                                : "https://via.placeholder.com/64x64/?text=no+image"
                            }
                          />
                        </div>
                      )
                    }
                    return null
                  })
              }
            </div>
            <div>
              <div className={`flex flex-row  relative space-x-1 h-6 w-full pr-8 sm:pr-0`}>
                {acf?.tenjinUpcomingContent &&
                  <div className="bg-red-800 px-2 relative rounded text-white w-content align-middle z-50 pt-0.5 bg-pill-upcoming">
                    <p className="font-medium text-xs md:text-sm">Upcoming</p>
                  </div>}
                {acf?.tenjinNewContent &&
                  <div className="px-2 relative rounded text-white w-content align-middle z-50 pt-0.5 bg-pill-new">
                    <p className="font-medium text-xs md:text-sm">New</p>
                  </div>}
                {acf?.tenjinPaidContent === 'paid' && urlbase !== 'tutorial' &&
                  <div className="px-2 relative rounded text-white w-content align-middle z-50 pt-0.5 bg-pill-paid">
                    <p className="font-medium text-xs md:text-sm">$Paid</p>
                  </div>}
                {acf?.tenjinPaidContent === 'free' && urlbase !== 'tutorial' &&
                  <div className="px-2 relative rounded text-white w-content align-middle z-50 pt-0.5 bg-pill-free">
                    <p className="font-medium text-xs md:text-sm">Free</p>
                  </div>}
                {!!acf.tenjinArticleNumber &&
                  <div className="px-2 relative rounded text-white w-content align-middle z-50 pt-0.5 bg-pill-articlenr">
                    <p className="font-medium text-xs md:text-sm">{acf.tenjinArticleNumber}</p>
                  </div>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  )
}